module.exports = __webpack_public_path__ + "static/media/multi-sports.64512a15.svg";